import { collection, query, where, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export const generateWarrantyId = async () => {
  const currentYear = new Date().getFullYear();
  const prefix = `MCAN-${currentYear}-`;
  
  try {
    const warrantyRef = collection(db, "warranty-card-details");
    const q = query(
      warrantyRef,
      where("warrantyId", ">=", prefix),
      where("warrantyId", "<=", prefix + "\uf8ff"),
      orderBy("warrantyId", "desc"),
      limit(1)
    );
    
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      return `${prefix}0001`;
    }
    
    const lastDoc = snapshot.docs[0].data();
    const lastId = lastDoc.warrantyId;
    
    if (lastId) {
      const lastNumber = parseInt(lastId.split("-")[2], 10);
      const newNumber = lastNumber + 1;
      return `${prefix}${newNumber.toString().padStart(4, "0")}`;
    }
    
    return `${prefix}0001`;
  } catch (error) {
    console.error("Error generating warranty ID:", error);
    // Fallback if query fails (e.g. index missing)
    const randomSuffix = Math.floor(1000 + Math.random() * 9000);
    return `${prefix}${randomSuffix}`;
  }
};
